import React, { useState, useEffect } from 'react';
import axios from 'axios';
import config from '../../../settings/config.json';
import { Button, Modal, Form, Input, Upload } from 'antd';
import { EditOutlined, DeleteOutlined, UploadOutlined } from '@ant-design/icons';

const { Dragger } = Upload;

function AllWriters() {
  const [writers, setWriters] = useState([]);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [currentWriter, setCurrentWriter] = useState(null);
  const [form] = Form.useForm();

  useEffect(() => {
    const fetchWriters = async () => {
      try {
        const response = await axios.get(`/api/writers`);
        setWriters(response.data);
      } catch (error) {
        console.error('ERROR:', error);
      }
    };

    fetchWriters();

    const interval = setInterval(fetchWriters, 3000);
    return () => clearInterval(interval);
  }, []);

  const showEditModal = (writer) => {
    setCurrentWriter(writer);
    form.setFieldsValue({ name: writer.name, surname: writer.surname, bio: writer.bio });
    setIsModalVisible(true);
  };

  const handleEditOk = async () => {
    try {
      const values = await form.validateFields();
      const formData = new FormData();

      formData.append('name', values.name);
      formData.append('surname', values.surname);
      formData.append('bio', values.bio);

      if (values.imageUpload && values.imageUpload.fileList.length > 0) {
        formData.append('imageFiles', values.imageUpload.fileList[0].originFileObj);
      }

      const response = await axios.put(`/api/writers/${currentWriter._id}`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      setWriters(writers.map(writer => writer._id === currentWriter._id ? response.data : writer));
      setIsModalVisible(false);
      setCurrentWriter(null);
    } catch (error) {
      console.error('ERROR:', error);
    }
  };

  const handleEditCancel = () => {
    setIsModalVisible(false);
    setCurrentWriter(null);
  };

  const handleDelete = async (id) => {
    try {
      await axios.delete(`/api/writers/${id}`);
      setWriters(writers.filter(writer => writer._id !== id));
    } catch (error) {
      console.error('ERROR:', error);
    }
  };

  return (
    <div className='Poems'>
      {writers.length > 0 ? (
        <ul className='message-list'>
          {writers.map(writer => (
            <li key={writer._id} className='message-item'>
              {writer.photo && (
                <img 
                  src={`/api${writer.photo}`}
                  alt="Avatar" 
                  className='avatar mt-3'
                />
              )}
              <div className='message-details'>
                <p className='name text-white'>{writer.name} {writer.surname}</p>
                <p className='message-content font-reqular text-white-50 spaces'>Şeir: <br /><p className='text-white font-reqular'>{writer.bio}</p></p>
                <p className='date'>{new Date(writer.date).toLocaleString()}</p>
              </div>
              <Button 
                className='like-button me-2 text-warning'
                icon={<EditOutlined />}
                onClick={() => showEditModal(writer)}
              />
              <Button 
                className='like-button me-2 text-danger'
                icon={<DeleteOutlined />}
                onClick={() => handleDelete(writer._id)}
              />
              <hr />
            </li>
          ))}
        </ul>
      ) : (
        <center className='mt-5'>
          <h2 className='text-gradient'>Oops...</h2>
          <h4 className='mt-3 text-secondary font-reqular'>Şeir yoxdur</h4>
          <br /><br /><br />
        </center>
      )}
      <Modal
        title="Şeir redaktə edin"
        visible={isModalVisible}
        onOk={handleEditOk}
        onCancel={handleEditCancel}
      >
        <Form
          form={form}
          layout="vertical"
          name="form_in_modal"
        >
          <Form.Item
            name="name"
            label="Ad"
            rules={[{ required: true, message: '' }]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            name="surname"
            label="Soyad"
            rules={[{ required: true, message: '' }]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            name="bio"
            label="Bio"
            rules={[{ required: true, message: '' }]}
          >
            <Input.TextArea rows={6} />
          </Form.Item>
          <Form.Item
              name="imageUpload"
              label="Photo"
              rules={[{ required: true }]}
            >
              <Dragger
                name="imageUpload"
                beforeUpload={() => false}
                multiple
                listType="text"
                onChange={({ fileList }) => {
                  form.setFieldsValue({ imageUpload: { fileList } });
                }}
              >
                <Button icon={<UploadOutlined />}>Upload</Button>
              </Dragger>
            </Form.Item>
        </Form>
      </Modal>
    </div>
  );
}

export default AllWriters;